import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../primary/InputField/InputField";
import style from "./RepeatableTextList.module.scss";

/**
 * RepeatableTextList - an add/remove list of plain text inputs (e.g. a customer's email
 * domains). Each row is independently controlled: the parent owns the array value and supplies
 * one error message per index.
 */
export const RepeatableTextList = ({ name, values = [""], errors = [], disabled, addLabel, canAdd = true, onItemChange, onAdd, onRemove }) => (
  <div className={style.list}>
    {values.map((value, index) => (
      <div className={style.row} key={`${name}-${index}`}>
        <div className={style.input}>
          <InputField
            id={`${name}${index}`}
            name={`${name}[${index}]`}
            dataTestId={`${name}_${index}`}
            value={value}
            disabled={disabled}
            onChange={(e) => onItemChange(index, e.target.value)}
            error={errors[index]}
          />
        </div>
        {values.length > 1 && !disabled && (
          <button type="button" className={style.remove} aria-label={`Remove ${name} ${index + 1}`} onClick={() => onRemove(index)}>
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        )}
      </div>
    ))}

    {!disabled && (
      <button type="button" className={style.add} disabled={!canAdd} onClick={onAdd}>
        {addLabel}
      </button>
    )}
  </div>
);

RepeatableTextList.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string),
  errors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  addLabel: PropTypes.node,
  canAdd: PropTypes.bool,
  onItemChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
